export default __webpack_public_path__ + "static/media/icon-5.3d5554ef.svg";